import { Button, Modal } from "react-bootstrap";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../helper/dateTimeHelper";
import _ from "lodash";

type HistoryModalType = {
    onClose:  () => void;
    isOpen: boolean;
    value: string;
    id: string | undefined
}

const ViewHistoryEditRepairToolsModal = (props: HistoryModalType) => {
    const { onClose, isOpen, value, id } = props;
    const historyList = value ? JSON.parse(value).filter((e: any) => e.id === id) : [];
    const sortedList = _.reverse(historyList);
    const getTime = (value: any) =>  id !== "broken" ? " - " + getHHmmFormat(value) : '';
    return (
      <Modal
        show={isOpen}
        onHide={onClose}
        size="lg"
        centered
        className="add-folder-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Lịch sử chỉnh sửa
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4 px-4">
        {
            sortedList.map((e:any, index: number) => {
              return <>
                <div key={index}>
                  <p>{e.user} <span className="text-secondary"> {"(" + getDDMMYYYFormat(e.modifiedDate) + " - " + getHHmmFormat(e.modifiedDate) + "): "} </span> {getDDMMYYYFormat(e.value) + getTime(e.value)} </p>
                </div>
              </>})      
        }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose} variant="info">
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

export default ViewHistoryEditRepairToolsModal;
